// Context 
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';
export const UPDATE_CODING_EVENT_QUEUE_FILTERS = 'UPDATE_CODING_EVENT_QUEUE_FILTERS';
export const UPDATE_CODING_EVENT_QUEUE_FILTER_PROPERTY = 'UPDATE_CODING_EVENT_QUEUE_FILTER_PROPERTY';
export const RESET_CODING_EVENT_QUEUE_FILTER = 'RESET_CODING_EVENT_QUEUE_FILTER';

// Modals 
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

// Messaging
export const ERROR_MESSAGE_RECIEVED = 'ERROR_MESSAGE_RECIEVED';

// Notifications 
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

// Spinner
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const OVERRIDE_SPINNER = 'OVERRIDE_SPINNER';